(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-centered-logo"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor(){ super(); }

  connectedCallback(){
    this.header = document.querySelector('.section-header');

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};

    this.updateOffsets = this.updateOffsets.bind(this);
    this.onScrollHandler = this.onScroll.bind(this);

    this.updateOffsets();

    window.addEventListener('resize', this.updateOffsets);
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.updateOffsets);
    window.addEventListener('scroll', this.onScrollHandler, false);

    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(this.updateOffsets);
      this.ro.observe(this.header);
      const bar = this.announcementBar();
      if (bar) this.ro.observe(bar);
    }

    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    this.createObserver();

    /* Replace drawer links with custom links when available */
    document.addEventListener('DOMContentLoaded', this.injectDrawerLinks.bind(this));
    document.addEventListener('click', (e) => {
      const el = e.target.closest('header-drawer, .menu-drawer__menu, .header__icon--menu, button[aria-controls="menu-drawer"], [data-action="open-drawer"]');
      if (el) { this.updateOffsets(); this.injectDrawerLinks(); }
    }, true);
  }

  announcementBar(){ return document.querySelector('.shopify-section-announcement-bar, .announcement-bar-section, .announcement-bar'); }

  injectDrawerLinks(){
    const extra = document.getElementById('kk-mobile-extra-links');
    const drawerNav = document.querySelector('.menu-drawer .menu-drawer__navigation');
    if (!extra || !drawerNav) return;

    /* Hide the built-in list if present */
    const builtIn = drawerNav.querySelector('.menu-drawer__menu');
    if (builtIn) builtIn.style.display = 'none';

    /* If we already injected once, stop */
    if (drawerNav.querySelector('.kk-drawer-extra')) return;

    /* Clone our list and insert */
    const clone = extra.cloneNode(true);
    clone.hidden = false;
    clone.classList.add('kk-drawer-extra');
    drawerNav.appendChild(clone);
  }

  updateOffsets(){
    const headerH = this.header?.offsetHeight || 64;
    let barH = 0;
    const bar = this.announcementBar();
    if (bar){
      const bh = bar.offsetHeight || 0;
      const scrolledPast = (window.scrollY || 0) >= bh;
      if (!scrolledPast && bh > 0) barH = bh;
    }
    document.documentElement.style.setProperty('--header-height', `${headerH}px`);
    document.documentElement.style.setProperty('--header-offset', `${headerH + barH}px`);
  }

  disconnectedCallback(){
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.updateOffsets);
    if (this.ro) this.ro.disconnect();
  }

  createObserver(){
    let o = new IntersectionObserver((e,obs)=>{ this.headerBounds = e[0].intersectionRect; obs.disconnect(); });
    o.observe(this.header);
  }

  onScroll(){
    this.updateOffsets();

    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (st > this.currentScrollTop && st > this.headerBounds.bottom){
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (st < this.currentScrollTop && st > this.headerBounds.bottom){
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal){ requestAnimationFrame(this.reveal.bind(this)); }
      else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(()=>{ this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (st <= this.headerBounds.top){
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = st;
  }

  hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
  reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
  reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
  closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d=>d.close()); }
  closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal && this.searchModal.close(false); }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
